import React, { useMemo, forwardRef } from 'react';
import { useTheme } from 'styled-components';

import { Text } from 'src/packages/core';
import { TextareaProps } from './Textarea.types';
import {
  StyledTextareaContainer,
  TextareaWrapper,
  StyledTextarea,
  getColorStyles,
} from './Textarea.styles';
import { MarginProps } from 'styled-system';
import { DarkTheme, LightTheme } from 'src/packages/theme';

const Textarea = forwardRef(
  (props: TextareaProps, ref: React.ForwardedRef<HTMLTextAreaElement>) => {
    const {
      label = undefined,
      errorMessage = undefined,
      readOnly = false,
      width,
      text = '',
      theme,
      ...rest
    } = props;

    const contextTheme = useTheme();

    const defaultTheme = useMemo(() => {
      return theme
        ? theme === 'light'
          ? { ...LightTheme, rtl: contextTheme.rtl }
          : { ...DarkTheme, rtl: contextTheme.rtl }
        : contextTheme;
    }, [contextTheme, theme]);

    const colorStyles = useMemo(() => {
      return getColorStyles(errorMessage, readOnly, defaultTheme);
    }, [errorMessage, readOnly, defaultTheme]);

    return (
      <StyledTextareaContainer width={width} {...(rest as MarginProps)}>
        {label && <Text text={label} variant='p2' color={defaultTheme.colors.text.primary} />}

        <TextareaWrapper defaulttheme={defaultTheme}>
          <StyledTextarea
            {...rest}
            ref={ref}
            readOnly={readOnly}
            defaulttheme={defaultTheme}
            themetype={theme}
            colorStyles={colorStyles}
          >
            {text}
          </StyledTextarea>
        </TextareaWrapper>

        {errorMessage && (
          <Text text={errorMessage} variant='p3' color={defaultTheme.colors.palette.red} />
        )}
      </StyledTextareaContainer>
    );
  }
);

export default Textarea;
